// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ResetPasswordError_wrapper__2Q1vc","icon":"ResetPasswordError_icon__J-9aK","errorText":"ResetPasswordError_errorText__2BXVB"};